
    var riot = require('riot')
    riot.tag2('pagination', '<nav class="myt-pagination" if="{showPreviousPageLink || showNextPageLink}"> <ul class="myt-pagination-list button-shadow"> <li class="myt-pagination-list-prev" if="{showPreviousPageLink}"> <a href onclick="{previousClicked}" class="secondary-action-search" data-nav rel="prev">&laquo;<span> Föregående</span></a> </li> <li each="{page, index in pages}" class="myt-pagination-list-number {first: index == 0} {last: index == pages.length - 1}"> <a class="active" if="{page.number == parent.currentNumber}">{page.label}</a> <a href onclick="{pageNumberClicked}" data-nav if="{page.number != parent.currentNumber && !!page.number}">{page.label}</a> <a if="{!page.number}">{page.label}</a> </li> <li class="myt-pagination-list-next" if="{showNextPageLink}"> <a href onclick="{nextClicked}" class="secondary-action-search" data-nav rel="next"><span>Nästa </span>&raquo;</a> </li> </ul> </nav>', '', '', function(opts) {
        var self = this;

        function paginationUpdated(pages, currentNumber, lastNumber) {
            self.showPreviousPageLink = pages.length > 0 && currentNumber > 1;
            self.showNextPageLink = pages.length > 1 && currentNumber < lastNumber;
            self.pages = pages;
            self.currentNumber = currentNumber;
            self.update();
        }

        this.opts.registerPaginationCallbackFunction(paginationUpdated);

        this.previousClicked = function () {
            if (self.opts.paginationClickedCallback) {
                self.opts.paginationClickedCallback(self.currentNumber - 1);
            }
            $(window).scrollTop(0);
        }.bind(this);
        this.nextClicked = function () {
            if (self.opts.paginationClickedCallback) {
                self.opts.paginationClickedCallback(self.currentNumber + 1);
            }
            $(window).scrollTop(0);
        }.bind(this);
        this.pageNumberClicked = function (evt) {
            if (self.opts.paginationClickedCallback) {
                self.opts.paginationClickedCallback(evt.item.page.number);
            }
            $(window).scrollTop(0);
        }.bind(this);
});
    
  


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/tags/pagination.riot.html